/**
 * 即构版权音乐
 * */
import { message } from 'antd';
import {
  getLocalStorageAdjustConfig,
  setLocalStorageAdjustConfig,
} from '../../components/ClickToSing/MusicAdjustModal';
import { isObject } from 'lodash-es';
import { _anly_seng_custom } from '../Action';
import Util from '../../script/util';

// 版权音乐错误码
const COPYRIGHT_MUSIC_ERROR_CODE = {
  1017019: '下载资源已过期，即将重新下载',
  1017014: '资源文件已过期，即将重新下载',
  1017015: '资源文件已损坏，即将重新下载',
  1017030: '音乐无版权，无法收听和点唱歌曲，联系主持跟换歌曲',
  1017031: '音乐无伴奏权限，只能收听歌曲，无法点唱，联系主持跟换歌曲',
  1017033: '该歌曲没有伴奏资源',
  1017034: '找不到该歌曲资源，请跟换歌曲',
  1017048: '获取歌词失败，请稍后重试',
  1017052: '无该歌曲版权，无法使用',
  1017098: '网络异常，请稍后重试',
  1017012: '有相同的资源正在下载中，请等待下载完成后重试~',
};

class ZegoElectronCopyrightMusic {
  constructor(props) {
    this.props = props;

    this.musicMedia = null; // 媒体播放器
    this.musicPlaying = false; // 媒体播放器是否在播放中
    this.nowMusicResourceInfo = null; // 当前播放的资源信息 - 获取逐行歌字需要
    this.downloadMusicList = null; // 下载的歌曲列表

    // 混响枚举
    this.musicPresetEnum = [
      { title: '3D', code: -1, codeNum: -1 },
      {
        title: 'KTV',
        code: this.props.zgDefines.ZegoReverbPreset.KTV,
        codeNum: 7,
      },
      {
        title: '摇滚',
        code: this.props.zgDefines.ZegoReverbPreset.Rock,
        codeNum: 9,
      },
      {
        title: '演唱会',
        code: this.props.zgDefines.ZegoReverbPreset.VocalConcert,
        codeNum: 10,
      },
      {
        title: '录音棚',
        code: this.props.zgDefines.ZegoReverbPreset.RecordingStudio,
        codeNum: 5,
      },
    ];

    this.initCopyrightedMusic();
  }

  /**
   * 初始化版权音乐
   * */
  initCopyrightedMusic = async () => {
    try {
      const roomInfo = this.props.room;
      const pidConfig = roomInfo?.baseRoomInfo?.zegoKey
        ? await Util.decryptContent(roomInfo.baseRoomInfo.zegoKey)
        : null;
      const pinConfigMap = {};
      if (pidConfig?.length) {
        pidConfig.forEach((n) => {
          pinConfigMap[n.pidKey] = n.pidValue;
        });
      }
      this.props.client.setEngineConfig({
        advancedConfig: pinConfigMap,
      });

      this.CopyrightedMusic = this.props.client.createCopyrightedMusic();
      await this.CopyrightedMusic.initCopyrightedMusic({
        user: this.props.zegoUser,
      });
      this.musicPlaying = false; // 版权音乐播放器状态

      this.bindEvent();
    } catch (err) {
      console.error('加载版权音乐失败:', err);
    }
  };

  /**
   * 绑定事件
   * */
  bindEvent = () => {
    this.props.client.on('onPlayerSyncRecvSEI', this.onPlayerSyncRecvSEI);
  };
  // 监听SEI数据 由于 electron 移除事件需要第二个参数
  onPlayerSyncRecvSEI = ({ streamID, data }) => {
    try {
      if (streamID) {
        if (streamID === this.props.streamID) {
          // 当前演唱的是我自己无需解析SEI
        } else {
          /*
           * json格式
           * {
           *  "keyProcessInMs": number, // 歌曲进度，单位毫秒
           *  "keyTotalInMs": number, // 歌曲总时长，单位毫秒
           *  "krc_token": string|null, // 即构歌曲歌词token
           *  "resourceID": string, // 即构歌曲资源ID
           *  "vendorSongID": string, // 即构歌曲ID
           *  "vendorID": string, // 即构歌曲供应商ID
           *  "songID": string, // 我们自己的歌曲ID
           *  "songName": string, // 即构歌曲名称
           *  "singerName": string, // 即构歌曲歌手
           * }
           * */
          const d = arrayBufferToString(data);
          const json = !!d && Util.isJSONStr(d) ? JSON.parse(d) : null;
          if (
            json &&
            json?.vendorSongID !== this.nowMusicResourceInfo?.vendorSongID
          ) {
            this.nowMusicResourceInfo = json;
          }
          if (this.nowMusicResourceInfo && json.keyProcessInMs != null) {
            this.props.room.events['COPYRIGHT_MUSIC_PROCESS'] &&
              this.props.room.events['COPYRIGHT_MUSIC_PROCESS'](
                json.keyProcessInMs
              );
          }
        }
      }
    } catch (error) {
      console.error('解析SEI失败', error);
    }
  };
  /**
   * 移除事件
   * */
  removeEvent = () => {
    this.props.client.off('onPlayerSyncRecvSEI', this.onPlayerSyncRecvSEI);
  };

  /**
   * 初始化版权音乐媒体播放器
   * */
  createMusicMedia = () => {
    // 版权音乐媒体播放器
    this.musicMedia = this.props.client.createMediaPlayer();
    this.musicMedia.enableAux(true); // 开启混音
    this.musicMedia.setProgressInterval(60);
    this.musicMedia.on('onMediaPlayerPlayingProgress', (info) => {
      const { millisecond } = info;
      this.props.room.events['COPYRIGHT_MUSIC_PROCESS'] &&
        this.props.room.events['COPYRIGHT_MUSIC_PROCESS'](millisecond);
      this.syncNowMusicLyrics(millisecond);
    });
    this.musicMedia.on('onMediaPlayerStateUpdate', ({ state, errorCode }) => {
      if (errorCode !== 0) {
        console.error('onMediaPlayerStateUpdate', state, errorCode);
      }
      // NoPlay: 不在播放 Playing: 播放中 Pausing: 暂停播放 PlayEnded: 播放结束
      if (state === this.props.zgDefines.ZegoMediaPlayerState.NoPlay) {
        // 不在播放
        this.musicPlaying = false;
      } else if (state === this.props.zgDefines.ZegoMediaPlayerState.Playing) {
        // 播放中
        this.musicPlaying = true;
      } else if (state === this.props.zgDefines.ZegoMediaPlayerState.Pausing) {
        // 暂停播放
        this.musicPlaying = false;
      } else if (
        state === this.props.zgDefines.ZegoMediaPlayerState.PlayEnded
      ) {
        // 结束播放
        this.musicPlaying = false;
        this.props.room.events['COPYRIGHT_MUSIC_PLAY_END'] &&
          this.props.room.events['COPYRIGHT_MUSIC_PLAY_END']();
      }
    });
  };
  /**
   * 获取音乐资源
   * @param songInfo 我们自己数据的歌曲信息
   * */
  async getMusicResource(songInfo, data, callback) {
    const { songId, songName, singerName } = songInfo;
    const curMusicRequestConfig = this.getDownloadMusicList(
      songId,
      'musicResourceInfo'
    );
    const result = data;
    if (
      curMusicRequestConfig &&
      result?.vendorSongId === curMusicRequestConfig?.vendorSongID
    ) {
      //  已缓存歌曲数据
      callback && callback({ errorCode: 0 });
    } else {
      if (result?.vendorSongId) {
        const musicRequestConfig = {
          songID: result.vendorSongId,
          vendorID: result.vendorId,
          mode: result.webBillingMode,
        };
        // 0: 按次计费 1: 按用户包月计费 2: 按房间包月计费 3: 按房主包月计费
        if (result.webBillingMode === 3) {
          if (!this.props.zegoUser.userID) {
            callback && callback({ errorCode: -1 });
            message.warning(`异常，请稍后操作或重新添加歌曲`);
            return;
          }
          musicRequestConfig.masterID = this.props.zegoUser.userID;
        }

        this.songID = result?.vendorSongId || this.songID;
        const typeSong =
          this.props.zgDefines.ZegoCopyrightedMusicResourceType
            .ZegoCopyrightedMusicResourceAccompaniment;
        this.CopyrightedMusic.requestResource(musicRequestConfig, typeSong)
          .then((res) => {
            if (res.errorCode === 0) {
              const resource = JSON.parse(res.resource);
              const resources = resource.data.resources;
              const len = resources?.length ?? 0;
              if (len === 0) {
                message.error('歌曲资源获取失败');
                console.error('获取歌曲资源列表获取失败', res);
              } else {
                const index =
                  this.props?.room?.baseRoomInfo?.chooseQualityLevel === 1
                    ? len - 1
                    : 0; // 选择第几个音乐资源
                const musicResourceID = resources[index].resource_id;

                // 用于同步歌词
                const musicResourceInfo = {
                  krc_token: resource.data?.krc_token ?? null,
                  resourceID: musicResourceID,
                  vendorSongID: musicRequestConfig.songID,
                  vendorID: musicRequestConfig.vendorID,
                  songID: songId,
                  songName: songName,
                  singerName: singerName,
                };
                this.saveDownloadMusicList(songId, { musicResourceInfo });
              }
            } else {
              _anly_seng_custom(1900, {
                data: { res, resource: { data, musicRequestConfig } },
              });
              let errorText = '获取歌曲资源失败，请稍后重试';
              if (COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]) {
                errorText = COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode];
              }
              message.error(errorText);
              console.error('获取歌曲资源失败', res);
            }
            callback && callback(res);
          })
          .catch((err) => {
            callback && callback(err);
          });
      } else {
        message.warning('请正确选择音乐');
      }
    }
  }
  /**
   * 下载歌曲
   * @param originID 我们自己的ID
   * @return 1 下载完成 2 下载失败
   * */
  downloadMusic = (songId, originID, callback = null) => {
    const musicResourceInfo = this.getDownloadMusicList(
      songId,
      'musicResourceInfo'
    );
    if (musicResourceInfo?.resourceID) {
      this.CopyrightedMusic.download(musicResourceInfo.resourceID).then(
        (res) => {
          if (res?.errorCode === 0) {
          } else if (
            res?.errorCode === 1017019 ||
            res?.errorCode === 1017014 ||
            res?.errorCode === 1017015
          ) {
            message.warning(COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]);
            this.deleteDownloadMusicList(songId);
          } else if (res?.errorCode === 1017012) {
            message.warning(COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]);
          } else {
            let errorText = '下载歌曲资源失败，请稍后重试';
            if (COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]) {
              errorText = COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode];
            }
            message.error(errorText);
          }
          callback && callback(res);
          this.props.room.events['COPYRIGHT_DOWNLOAD_STATUS'] &&
            this.props.room.events['COPYRIGHT_DOWNLOAD_STATUS'](
              res?.errorCode === 0,
              originID
            );
          if (res?.errorCode !== 0) {
            _anly_seng_custom(1901, {
              data: { res, resource: musicResourceInfo },
            });
            console.error('下载歌曲资源失败', res);
          }
        }
      );
    } else {
      message.warning('无法下载');
      console.error('歌曲资源异常，请重试下载', musicResourceInfo);
      callback && callback({ errorCode: 1 });
      this.props.room.events['COPYRIGHT_DOWNLOAD_STATUS'] &&
        this.props.room.events['COPYRIGHT_DOWNLOAD_STATUS'](2, originID);
    }
  };
  /**
   * 加载音乐资源
   * */
  loadMusicResourceWith = (songId, callback) => {
    const musicResourceInfo = this.getDownloadMusicList(
      songId,
      'musicResourceInfo'
    );
    if (musicResourceInfo) {
      this.musicMedia
        .loadCopyrightedMusicResourceWithPosition(
          musicResourceInfo.resourceID,
          0
        )
        .then((res) => {
          if (res?.errorCode === 0) {
            this.nowMusicResourceInfo = musicResourceInfo;

            const audioTrackCount = this.musicMedia.getAudioTrackCount();
            if (audioTrackCount === 1) {
              // 无伴奏，阻止控制切换 伴奏/原唱 空间
              setLocalStorageAdjustConfig('isOriginalVocal', true);
            }
            const accVolume = getLocalStorageAdjustConfig('accVolume');
            const voiceTone = getLocalStorageAdjustConfig('voiceTone');
            const isOpen3D = getLocalStorageAdjustConfig('isOpen3D') || false;

            if (accVolume === 0) {
              message.info('您当前演唱的歌曲音量为0哦，请前往调音台修改音量!');
            }
            this.changeMusicVolume(accVolume); // 设置媒体播放器音量
            this.changeHeadphoneMonitor(false); // 关闭耳返监听
            this.changeMusicPreset(0); // 重置音效
            this.enableLiveAudioEffect(!!isOpen3D);
            this.setVoiceChangerParam(voiceTone);
            this.startMusic();
          }
          if (res?.errorCode !== 0) {
            let errorText = '加载歌曲资源失败，请稍后重试';
            if (COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]) {
              errorText = COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode];
            }
            _anly_seng_custom(1903, {
              data: {
                res,
                resource: { musicResourceInfo },
              },
            });
            message.error(errorText);
          }
          callback && callback(res);
        });
    } else {
      message.warning('歌曲资源已失效，请重试开始演唱');
      callback && callback({ errorCode: 1 });
    }
  };
  /**
   * 开始播放
   * */
  startMusic = () => {
    if (this.musicPlaying) {
      this.musicMedia.stop();
    }

    this.checkMusicOrigin(true, 'auto');
    this.nowCopyMusicDuration = this.musicMedia.getTotalDuration(); // 获取音乐时长
    this.musicMedia.start();
  };
  /**
   * 重唱
   * */
  againMusic = () => {
    if (this.musicMedia) {
      this.startMusic();
    }
  };
  /**
   * 获取逐行/逐字歌词
   * */
  getLrcLyric = (callback) => {
    if (this.nowMusicResourceInfo?.krc_token) {
      // 逐字歌词
      this.CopyrightedMusic.getKrcLyricByToken(
        this.nowMusicResourceInfo.krc_token
      ).then((res) => {
        if (res?.errorCode === 0) {
          if (res?.lyrics && typeof res.lyrics === 'string') {
            res.lyrics = JSON.parse(res.lyrics);
          }
        } else {
          _anly_seng_custom(1902, {
            data: { res, resource: this.nowMusicResourceInfo },
          });
          let errorText = '获取歌曲歌词失败，请稍后重试';
          if (COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]) {
            errorText = COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode];
          }
          message.error(errorText);
          console.error('获取歌曲逐步歌词失败', res);
        }
        callback && callback(res);
      });
    } else if (this.nowMusicResourceInfo?.vendorSongID) {
      // 逐行歌词
      this.CopyrightedMusic.getLrcLyricWithVendorID(
        this.nowMusicResourceInfo.vendorSongID,
        this.nowMusicResourceInfo.vendorID
      ).then((res) => {
        if (res?.errorCode === 0) {
          if (res?.lyrics && typeof res.lyrics === 'string') {
            res.lyrics = JSON.parse(res.lyrics);
          }
        } else {
          _anly_seng_custom(1902, {
            data: { res, resource: this.nowMusicResourceInfo },
          });
          let errorText = '获取歌曲歌词失败，请稍后重试';
          if (COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode]) {
            errorText = COPYRIGHT_MUSIC_ERROR_CODE[res.errorCode];
          }
          message.error(errorText);
          console.error('获取歌曲逐行歌词失败', res);
        }
        callback && callback(res);
      });
    } else {
      // 无法正确获取歌词
      message.warning('请正确选择音乐');
      console.warn('未获歌词数据异常', this.nowMusicResourceInfo);
      callback(null);
    }
  };
  /**
   * 开始滚动歌词
   * @param {zegoViewInstance} zegoLyricInstance 即构歌词组件实例
   * @param {number} currentTime 歌词当前时间
   * */
  startRollingLyrics(zegoLyricInstance, currentTime) {
    // 更新本地歌词播放进度
    zegoLyricInstance.setCurrentTimeMillis(currentTime);
  }
  /**
   * 演唱者同步歌词进度
   * @param {number} currentTime 歌词进度
   * */
  syncNowMusicLyrics = (currentTime) => {
    // 歌词的 krc_token 也需要通过信令的方式传递给其他端
    if (this.musicPlaying) {
      // 将歌词播放进度通过 SEI 传出去
      const info = {
        keyProcessInMs: currentTime,
        keyTotalInMs: this.nowCopyMusicDuration,
        ...(this.nowMusicResourceInfo || {}),
      };
      let uint8Array = new TextEncoder().encode(JSON.stringify(info));
      this.props.client.sendSEI(uint8Array.buffer);
    }
  };
  /**
   * 切换伴奏和原唱
   * @param {boolean} isOrigin 是否开启原唱
   * @param {string} source 来源
   * @param {function|null} callback 回调
   * */
  checkMusicOrigin = (isOrigin = false, source, callback = null) => {
    if (this.musicMedia) {
      const getAudioTrackCount = this.musicMedia.getAudioTrackCount();
      if (getAudioTrackCount === 1) {
        // 如果只有一个音轨，则无法切换伴奏
        this.musicMedia.setAudioTrackIndex(1);
        if (!isOrigin) {
          message.warning('当前没有伴奏，无法切换哦~');
          callback && callback('error');
        } else {
          callback && callback();
        }
      } else {
        if (source === 'auto') {
          const isOriginalVocal =
            getLocalStorageAdjustConfig('isOriginalVocal') ?? true;
          this.musicMedia.setAudioTrackIndex(isOriginalVocal ? 1 : 0);
        } else if (isOrigin) {
          this.musicMedia.setAudioTrackIndex(1);
        } else {
          this.musicMedia.setAudioTrackIndex(0);
        }
        callback && callback();
      }
    } else {
      message.warning('当前没有正在播放的歌曲哦~');
      callback && callback();
    }
  };
  /**
   * 修改音量
   * @param {number} volume 音量
   * */
  changeMusicVolume = (volume = 60) => {
    volume = volume == null ? 60 : volume;
    if (this.musicMedia) {
      this.musicMedia.setVolume(volume);
    } else {
      message.warning('当前没有正在播放的歌曲哦~');
    }
  };
  /**
   * 设置耳返
   * @param {boolean} enable 是否开启耳返
   * */
  changeHeadphoneMonitor = (enable = false) => {
    this.props.client.enableHeadphoneMonitor(!!enable);
  };
  /**
   * 设置混响
   * @param {this.musicPresetEnum.code} preset 音量
   * */
  changeMusicPreset = (preset = 0) => {
    if (preset === -1) {
      // 虚拟立体声
      this.changeMusicVirtualStereo(true, -1);
      this.props.client.setReverbPreset(0);
    } else if (preset === 0) {
      // 关闭混响
      this.changeMusicVirtualStereo(false); // 关闭虚拟立体声
      this.props.client.setReverbPreset(0);
    } else {
      // 设置混响
      this.changeMusicVirtualStereo(false); // 关闭虚拟立体声
      this.props.client.setReverbPreset(preset);
    }
  };
  /**
   * 设置虚拟立体声
   * */
  changeMusicVirtualStereo = (enable = false, angle = -1) => {
    this.props.client.enableVirtualStereo(!!enable, angle);
  };
  /**
   * 开启关闭音效增强
   * @param player {HTMLMediaElement} 媒体播放器HTML
   * @param enable {boolean} 是否开启
   * @param mode {ZegoLiveAudioEffectMode} 类型
   * */
  enableLiveAudioEffect = (enable, mode) => {
    if (Util.checkClientVersion(316)) {
      if (mode == null) {
        mode = this.props.zgDefines.ZegoLiveAudioEffectMode.All;
      }
      this.musicMedia.enableLiveAudioEffect(!!enable, mode);
    }
  };
  /**
   * 变声处理
   * @param number {number} 音调参数 [-12.0, 12.0]
   * */
  setVoiceChangerParam = (voiceParam = 0) => {
    if (Util.checkClientVersion(316)) {
      this.props.client.setVoiceChangerParam({ pitch: parseFloat(voiceParam) });
    }
  };
  /**
   * 获取已经加载好，下载好的歌曲
   * */
  getDownloadMusicList = (songID, key) => {
    if (this.downloadMusicList && this.downloadMusicList[songID]) {
      if (key == null) {
        return this.downloadMusicList[songID];
      } else {
        return this.downloadMusicList[songID][key];
      }
    }
    return null;
  };
  /**
   * 保存已经加载好，下载好的歌曲
   * @param {string} songID 歌曲ID 我们自己的歌曲ID
   * @param {object} value 歌曲信息
   * */
  saveDownloadMusicList = (songID, value) => {
    if (this.downloadMusicList == null) this.downloadMusicList = {};
    this.downloadMusicList[songID] = value; // 保存下载的音频信息
  };
  /**
   * 删除已经加载好，下载好的歌曲
   * */
  deleteDownloadMusicList = (songID) => {
    if (isObject(this.downloadMusicList)) {
      const song = this.downloadMusicList[songID];
      if (song) {
        delete this.downloadMusicList[songID];
      }
    }
  };
  /**
   * 结束演唱
   * */
  endMusicPlaying = () => {
    if (this.musicMedia) {
      this.musicMedia.stop();
    }
    this.MusicPlaying = false;
    this.clearMusicResourceInfo = null;
  };

  /**
   * 销毁媒体播放器
   * */
  destroyMedia = () => {
    if (this.musicMedia) {
      this.endMusicPlaying();
      this.props.client.destroyMediaPlayer(this.musicMedia);
      this.musicMedia = null;
    }
  };

  /**
   * 销毁版权音乐
   * */
  destroy = () => {
    this.removeEvent();
    this.destroyMedia();
    this.props.client.destroyCopyrightedMusic(this.CopyrightedMusic);
  };
}

export default ZegoElectronCopyrightMusic;

// arrayBuffer转string
function arrayBufferToString(buf) {
  try {
    const encodedString = String.fromCharCode.apply(null, new Uint8Array(buf));
    return decodeURIComponent(escape(encodedString));
  } catch (e) {
    // console.error('arrayBufferToString err: ', e);
    return null;
  }
}
